<template>
  <div role="status" :aria-label="label">
    <div
      class="animate-spin rounded-full border-2 border-current border-t-transparent"
      :class="sizeClass"
    />
    <span class="sr-only">{{ label }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    label?: string;
    size?: "sm" | "md" | "lg";
  }>(),
  {
    label: "Loading",
    size: "md",
  },
);

const sizeClass = computed(() => {
  switch (props.size) {
    case "sm":
      return "size-4";
    case "lg":
      return "size-8";
    default:
      return "size-6";
  }
});
</script>
